import { defineStore } from 'pinia'

import logger from '@/services/logger'
import Notifications from '@/services/models/Notifications'

function hash(string) {
  var hash = 0
  if (string.length == 0) return hash
  for (let i = 0; i < string.length; i += 1) {
    const ch = string.charCodeAt(i)
    hash = (hash << 5) - hash + ch
    hash = hash & hash
  }
  return hash
}

export const useNotificationsStore = defineStore('notificationStore', {
  namespaced: true,
  state: () => ({
    notifications: [],
    notificationHash: null,
    hasNewNotifications: false,
    counter: 0,
    isFetching: false,
    interval: null, // Sem isso aqui a gente tá fudido
    selectedNotification: {},
    sidePanel: '',
  }),
  actions: {
    async fetchNotifications() {
      if (this.isFetching) return // Proteçaum

      this.isFetching = true

      try {
        const resp = await Notifications.listNotifications(
          '?notification__has_read=false&ordering=-created_at&custom_page_size=5',
        )
        const notifications = resp.data.results
        const hashed = hash(JSON.stringify(notifications))

        if (hashed !== this.notificationHash) {
          this.hasNewNotifications = true
          this.notifications = notifications
          this.counter = notifications.length
          this.notificationHash = hashed
        }
      } catch (error) {
        logger.warn('[Notifications] falha ao buscar notificações', error)
      } finally {
        this.isFetching = false
      }
    },
    startNotificationPolling() {
      if (this.interval) {
        return
      }

      this.fetchNotifications() // Primeira chamada

      const interval = setInterval(() => {
        this.fetchNotifications()
      }, 10000)

      this.interval = interval
    },
    stopNotificationPolling() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
  },
  getters: {
    getNotifications: state => state.notifications,
    getCounter: state => state.counter,
    getHasNewNotifications: state => state.hasNewNotifications,
    getSelectedNotification: state => state.selectedNotification,
  },
})
